import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import { SimpleWrapper } from "components/InputsMex/containers";
import { DropDownFilter, TextInput, TextInputOnBlur } from "components/InputsMex/inputs";
import { SimpleMaskInputField } from "components/InputsMex/SimpleInputs";
import { emailRegex, inputNumericoEnteros } from "components/InputsMex/validaciones";
import InformacionAgente from "components/MisDatosForm/InformacionAgente";
import Page from "components/Page";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import useUsuario from "hooks/useUsuario";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { guardarTrackingV2 } from "utils/tracking";
import { regex } from "utils/validaciones";
import Loading from "wrappers/Loading";
import useSuscriptorFunctions from "../components/useSusciptorFunctions";
import { CASUALITY } from "../constantes";
import { validarLimites } from "../constantes/funciones";
import { AgentesSuscriptor } from "./AgentesSuscriptor/AgentesSuscriptor";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import useQuickNotes from "hooks/useQuickNotes";

const API = ApiKeyFetch.instance();

export const InformacionCliente = () => {
  const params = useQueryParams();
  const { id = "" } = params;
  const history = useHistory();
  const { cliCodigoCore = "" } = useUsuario();
  const dataUsuario = useUsuario();
  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, reset } = methods;
  const suscriptorFunctions = useSuscriptorFunctions();
  const { addWarningToast } = useCustomToast();
  const quickNotes = useQuickNotes();

  const [loading, setLoading] = useState(false);
  const [loadingAgentes, setLoadingAgentes] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const [agenteFlow, setAgenteFlow] = useState(false);
  const [resumenAgente, setResumenAgente] = useState({});
  const [listadoAgentes, setListadoAgentes] = useState(null);

  const onSubmit = async (values) => {
    guardarTrackingV2(
      params?.id || "",
      "Click Continuar pantalla 1",
      "Guardado Leads"
    );
    const { ...rest } = values;
    console.log(values);
    setLoading(true);
    try {
      const Body = {
        ...rest,
        idCotizacion: id,
      };
      const { suscriptor, agente } = values;
      console.log(agente, "");
      if (dataUsuario?.isSuscriptor) {
        Body.usuCotiza = {
          ...Body.usuCotiza,
          idSuscriptor: cliCodigoCore,
        }
        if (!agenteFlow) {
          Body.usuCotiza = {
            ...Body.usuCotiza,
            idUsuario: suscriptor?.cliCodigoCore,
            codigoAgente: suscriptor?.agente?.value?.codigoAgente 
                            ? suscriptor?.agente?.value?.codigoAgente
                            : suscriptor?.agente?.codigoAgente,
          }
        } else {
          Body.usuCotiza = {
            ...Body.usuCotiza,
            idUsuario: resumenAgente.usuCodigo,
            codigoAgente: resumenAgente?.codigoAgente,
          }
        }
      } else {
        Body.usuCotiza = {
          idUsuario: cliCodigoCore,
          codigoAgente: agente?.codigoAgente,
        }
      }
      console.log("cuerpo", Body);
      const response = await API.post(CASUALITY.endpointsV2.guardarLead, Body);
      console.log("respuesta", response);
      quickNotes.validarRespuesta(response);
      if (response?.transaccion === true) {
        return history.push(`${CASUALITY.urls.datosGenerales}?id=${response?.id}`);
      }
      methods.reset({ ...values });
    } catch (error) { 
      methods.reset({ ...values });
      console.log(error);
    }
    setLoading(false);
  };
  const getListadoAgentes = async (Body) => {
    try {
      setLoadingAgentes(true);
      const responseList = await API.post(CASUALITY.endpointsV2.getUsuarioSuscriptor, Body);
      setListadoAgentes(responseList?.listadoAgentes || []);
      setLoadingAgentes(false);
    } catch (error) { };
  }

  const init = useCallback(async () => {
    guardarTrackingV2(
      id || "",
      "Carga pantalla 1",
      "Consulta catalogo"
    );
    setLoading(true);
    const Body = {
      usuCotiza: {
        idUsuario: cliCodigoCore,
      },
    };
    try {
      const [responseCatalogo, responseResumen] = await Promise.all([
        API.post(CASUALITY.endpointsV2.catalogo, Body),
        API.post(CASUALITY.endpointsV2.resumen, { idCotizacion: id }),
      ]);
      console.log(responseCatalogo, responseResumen);
      if (responseCatalogo?.transaccion === true) setCatalogo(responseCatalogo);
      if (responseResumen?.transaccion === true) {
        const { redirect, link } = await suscriptorFunctions.validate({ ...responseResumen, pasoActual: "leadPasoEquivalencia" }, dataUsuario);
        if (redirect) return history.push(link);
        const moneda = responseCatalogo?.monedas?.find(
          (item) => item?.value === responseResumen?.carrito?.carContratante?.moneda
        );
        if (responseResumen?.carrito?.carContratante.agente) {
          setAgenteFlow(true);
          setResumenAgente(responseResumen?.carrito?.carAsesor);
        }
        reset({ ...responseResumen?.carrito?.carContratante, moneda });
      }
    } catch (error) { }
    setLoading(false);
    getListadoAgentes(Body);
  }, []);

  useEffect(() => {
    if (dataUsuario.isDTC) {
      addWarningToast("Por favor, inicie sesión para continuar con la cotización");
      return history.push("/");
    }
    init();
  }, []);

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY].breadCrumbPasosCotizacion[1]}
            styleimg='height200px mr-3'
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY]?.pasosCotizacion}
          />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='d-flex justify-content-center'>
                <div className='col-lg-8 col-12'>
                  <div className='row w-100'>

                    <div className='col-12 col-md-6  py-4'>
                      <div className='container-accidentes'>
                        <h3 className='font-mex text-center' style={{ fontSize: "30px" }}>
                          Datos para la cotización
                        </h3>

                        <div className='form-group'>
                          <SimpleWrapper label='Tipo de Póliza*' name='tipoPoliza' showOk={false}>
                            <DropDownFilter
                              name='tipoPoliza'
                              options={
                                catalogo?.tipoPolizas?.map((item) => ({
                                  label: item.label,
                                  value: item,
                                })) || []
                              }
                              rules={{ required: "Este campo es obligatorio", }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='form-group'>
                          <SimpleWrapper label='Moneda' name='moneda' showOk={false}>
                            <DropDownFilter
                              name='moneda'
                              options={
                                catalogo?.monedas?.map((item) => ({
                                  label: item.label,
                                  value: item,
                                })) || []
                              }
                              rules={{
                                required: "Este campo es obligatorio",
                              }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='form-group'>
                          <SimpleWrapper label='Rubros*' name='rubros' showOk={false}>
                            <DropDownFilter
                              name='rubros'
                              options={
                                catalogo?.rubros?.map((item) => ({
                                  label: item.label,
                                  value: item,
                                })) || []
                              }
                              rules={{
                                required: "Este campo es obligatorio",
                              }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='form-group'>
                          <SimpleWrapper label='Giro' name='giro' showOk={false}>
                            <TextInput
                              inputProps={{
                                name: "giro",
                                type: "text",
                              }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='form-group'>
                          <SimpleWrapper
                            label='Suma Asegurada*'
                            name='sumaAsegurada'
                            showOk={false}>
                            <TextInputOnBlur
                              inputProps={{
                                name: "sumaAsegurada",
                                type: "number",
                                onKeyDown: inputNumericoEnteros,
                              }}
                              prefijo='$ '
                              numerico={true}
                              rules={{
                                required: "Este campo es obligatorio",
                                validate: {
                                  limits: (value) => {
                                    if (catalogo?.validaciones?.["valorContrato"]) {
                                      if (methods.watch("moneda")?.value === 1) {
                                        return validarLimites(
                                          value,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.dolares?.max,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.dolares?.min,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.dolares
                                            ?.msgError
                                        );
                                      }
                                      if (methods.watch("moneda")?.value === 0) {
                                        return validarLimites(
                                          value,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.pesos?.max,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.pesos?.min,
                                          catalogo?.validaciones?.["sumaAsegurada"]?.pesos?.msgError
                                        );
                                      }
                                      return true;
                                    }
                                  },
                                },
                              }}
                              extrasClasses='hide-arrows'
                            />
                          </SimpleWrapper>
                        </div>

                        {methods.watch("tipoPoliza")?.value === "coberturaPorContrato" && (
                          <div className='form-group'>
                            <SimpleWrapper
                              label='Valor del Contrato*'
                              name='valorContrato'
                              showOk={false}>
                              <TextInputOnBlur
                                inputProps={{
                                  name: "valorContrato",
                                  type: "number",
                                  onKeyDown: inputNumericoEnteros,
                                }}
                                prefijo='$ '
                                numerico={true}
                                rules={{
                                  required: "Este campo es obligatorio",
                                  validate: {
                                    limits: (value) => {
                                      if (catalogo?.validaciones?.["valorContrato"]) {
                                        if (methods.watch("moneda")?.value === 1) {
                                          return validarLimites(
                                            value,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares?.max,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares?.min,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares
                                              ?.msgError
                                          );
                                        }
                                        if (methods.watch("moneda")?.value === 0) {
                                          return validarLimites(
                                            value,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos?.max,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos?.min,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos
                                              ?.msgError
                                          );
                                        }
                                        return true;
                                      }
                                    },
                                  },
                                }}
                                extrasClasses='hide-arrows'
                              />
                            </SimpleWrapper>
                            <SimpleWrapper
                              label='Número del contrato*'
                              name='numeroContrato'
                              showOk={false}>
                              <TextInputOnBlur
                                inputProps={{
                                  name: "numeroContrato",
                                  type: "text",
                                }}
                                rules={{
                                  required: "Este campo es obligatorio",
                                }}
                                extrasClasses='hide-arrows'
                              />
                            </SimpleWrapper>
                          </div>
                        )}

                        {methods.watch("tipoPoliza")?.value === "anualPorOperaciones" && (
                          <div className='form-group'>
                            <SimpleWrapper
                              label='Estimado anual de venta*'
                              name='estimadoAnual'
                              showOk={false}>
                              <TextInputOnBlur
                                inputProps={{
                                  name: "estimadoAnual",
                                  type: "number",
                                  onKeyDown: inputNumericoEnteros,
                                }}
                                prefijo='$ '
                                numerico={true}
                                rules={{
                                  required: "Este campo es obligatorio",
                                  validate: {
                                    limits: (value) => {
                                      if (catalogo?.validaciones?.["valorContrato"]) {
                                        if (methods.watch("moneda")?.value === 1) {
                                          return validarLimites(
                                            value,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares?.max,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares?.min,
                                            catalogo?.validaciones?.["valorContrato"]?.dolares
                                              ?.msgError
                                          );
                                        }
                                        if (methods.watch("moneda")?.value === 0) {
                                          return validarLimites(
                                            value,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos?.max,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos?.min,
                                            catalogo?.validaciones?.["valorContrato"]?.pesos
                                              ?.msgError
                                          );
                                        }
                                        return true;
                                      }
                                    },
                                  },
                                }}
                                extrasClasses='hide-arrows'
                              />
                            </SimpleWrapper>
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div className='col-12 col-md-6  py-4'>
                      <div className='container-accidentes'>
                        <h3 className='font-mex text-center' style={{ fontSize: "30px" }}>
                          Datos del asegurado
                        </h3>

                        <div className='form-group'>
                          <SimpleWrapper label='Nombre*' name='usuNombre' showOk={false}>
                            <TextInputOnBlur
                              inputProps={{
                                name: "usuNombre",
                                type: "text",
                              }}
                              rules={{
                                required: regex.requiredMessage,
                                pattern: {
                                  value: regex.nombre.value,
                                  message: regex.nombre.mensaje,
                                },
                              }}
                            />
                          </SimpleWrapper>
                        </div>
                        
                        <div className='form-group'>
                          <SimpleWrapper label='RFC del asegurado*' name='usuRfc' showOk={false}>
                            <TextInputOnBlur
                              inputProps={{
                                name: "usuRfc",
                              }}
                              extrasClasses='hide-arrows'
                              rules={{
                                required: "Este campo es obligatorio",
                                pattern: {
                                  value: /^[A-Z]{3,4}[0-9]{6}[A-Z0-9]{3}$/,
                                  message:
                                    "RFC incorrecto, el formato debe ser: AAAA######*** o AAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos",
                                },
                                maxLength: {
                                  value: 13,
                                  message: "Ingrese hasta 13 caracteres",
                                },
                              }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='form-group container-accidentes w-100'>
                          <SimpleMaskInputField
                            name='usuTelefono'
                            label='Teléfono (opcional)'
                            type='mask'
                            placeholder='999-9999-999'
                            mask='999-9999-999'
                            isNumberInt={true}
                            inputProps={{
                              name: "usuTelefono",
                              type: "number",
                              onKeyDown: inputNumericoEnteros,
                            }}
                            classContainer='hide-arrows'
                            rules={{
                              pattern: {
                                value: regex.telefono10.value,
                                message: regex.telefono10.mensaje,
                              },
                              minLength: {
                                value: 10,
                                message: "Debe ingresar mínimo 10 números",
                              },
                              maxLength: {
                                value: 20,
                                message: "Solo puede ingresar máximo 20 números",
                              },
                            }}
                          />
                        </div>

                        <div className='form-group container-accidentes w-100 '>
                          <p
                            className='text-enviar-cotizacion'
                            style={{ fontSize: "20px", fontFamily: "Futura-Medium" }}>
                            Compártenos tu correo para enviarte tu cotización
                          </p>
                        </div>

                        <div className='form-group'>
                          <SimpleWrapper label='Correo (opcional)' name='usuCorreo' showOk={false}>
                            <TextInputOnBlur
                              inputProps={{
                                name: "usuCorreo",
                              }}
                              extrasClasses='hide-arrows'
                              rules={{
                                validate: {
                                  email: (value) => {
                                    if (value === "" || !value) return true;
                                    
                                    const valid = emailRegex.test(value);
                                    if (!valid) return "Ingrese un correo válido";
                                    
                                    return true;
                                  },
                                },
                              }}
                            />
                          </SimpleWrapper>
                        </div>

                        <div className='container-accidentes'>
                          <div
                            className='disclaimer-form-datos'
                            style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                            dangerouslySetInnerHTML={{
                              __html: catalogo?.textos?.texto,
                            }}
                          />
                        </div>

                        {
                          !dataUsuario?.isSuscriptor || agenteFlow ?
                            (
                              <InformacionAgente
                                className='mt-3'
                                border={false}
                                options={catalogo?.permisos?.agentes}
                              />
                            ) : (
                              <AgentesSuscriptor
                                name='suscriptor'
                                options={listadoAgentes}
                                props={{ loading: loadingAgentes, loadingText: "Cargando..." }}
                              />
                            )
                        }

                        <div className='d-flex justify-content-center mt-5'>
                          <Button type='submit' className='w-75'>
                            CONTINUAR
                          </Button>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
